/*
 * @Description: 创建投票模块
 * @Author: ywl
 * @Date: 2021-03-05 14:27:42
 * @LastEditors: lks
 * @LastEditTime: 2021-09-23 17:14:16
 */
import http from "@/plugin/axios";
// import { Apis } from '../index';
import { getSubName } from "@/utils/getHost";
export default {
  // 统计--选手投票结果
  getStatisticsPlayerList: (data: any): Promise<any> => {
    return http.post("activity/player/getStatisticsPlayerList", data);
  },
  // 新建or修改活动
  //  基本设置
  getVote: (data: any): Promise<any> => {
    return http.post("activity/vote/getVote", data);
  },
  saveOrUpdateVote: (data: any): Promise<any> => {
    return http.post("activity/vote/saveOrUpdateVote", data);
  },
  saveOrUpdateToAloneVote: (data: any): Promise<any> => {
    return http.post("activity/vote/saveOrUpdateToAloneVote", data);
  },
  getPageWxAppletPicture: (data: any): Promise<any> => {
    return http.post("activity/vote/getPageWxAppletPicture", data);
  },
  //  选手管理
  getPlayerList: (data: any): Promise<any> => {
    return http.post("activity/player/getPlayerList", data);
  },
  //查询选手分组
  getPlayerTypeList: (data: any): Promise<any> => {
    return http.post("activity/player/getPlayerTypeList", data);
  },
  //保存or更新分组新增参数
  saveOrUpdateWxPlayerType: (data: any): Promise<any> => {
    return http.post("activity/player/saveOrUpdateWxPlayerType", data);
  },
  delWxPlayerType: (data: any): Promise<any> => {
    return http.post("activity/player/delWxPlayerType", data);
  },
  delWxPlayer: (data: any): Promise<any> => {
    return http.post("activity/player/delWxPlayer", data);
  },
  getAddWxPlayerType: (data: any): Promise<any> => {
    return http.post("activity/player/getAddWxPlayerType", data);
  },
  addPlayer: (data: any): Promise<any> => {
    return http.post("activity/player/addPlayer", data);
  },
  saveOrUpdatePlayer: (data: any): Promise<any> => {
    return http.post("activity/player/saveOrUpdatePlayer", data);
  },
  batchAdd: (data: any): Promise<any> => {
    return http.post("activity/player/batchAddPlayer", data);
  },
  batchNameAddPlayer: (data: any): Promise<any> => {
    return http.post("activity/player/batchNameAddPlayer", data);
  },
  updatePlayerByNoOrName: (data: any): Promise<any> => {
    return http.post("activity/player/updatePlayerByNoOrName", data);
  },
  // 高级设置
  getVoteSetting: (data: any): Promise<any> => {
    return http.post("activity/vote/getVoteSetting", data);
  },
  saveOrUpdateVoteSetting: (data: any): Promise<any> => {
    return http.post("activity/vote/saveOrUpdateVoteSetting", data);
  },
  getMusicList: (data: any): Promise<any> => {
    return http.post("activity/vote/getMusicList", data);
  },
  getMusicByVoteId: (data: any): Promise<any> => {
    return http.post("activity/vote/getMusicByVoteId", data);
  },
  delSignUp: (data: any): Promise<any> => {
    return http.post("activity/vote/delSignUp", data);
  },
  saveOrUpdateMusic: (data: any): Promise<any> => {
    return http.post("activity/vote/saveOrUpdateMusic", data);
  },
  getLocalMusicByVoteId: (data: any): Promise<any> => {
    return http.post("activity/vote/getLocalMusicByVoteId", data);
  },
  // pc端--活动列表
  getVoteList: (data: any): Promise<any> => {
    return http.post("activity/vote/getVoteList", data);
  },
  getVoteSuspendOrStart: (data: any): Promise<any> => {
    return http.post("activity/vote/getVoteSuspendOrStart", data);
  },
  getCopeVote: (data: any): Promise<any> => {
    return http.post("activity/vote/getCopeVote", data);
  },
  getDelVote: (data: any): Promise<any> => {
    return http.post("activity/vote/getDelVote", data);
  },
  getClearVotes: (data: any): Promise<any> => {
    return http.post("activity/vote/getClearVotes", data);
  },
  getWxAppletVoteSignUp: (data: any): Promise<any> => {
    return http.post("activity/vote/getWxAppletVoteSignUp", data);
  },
  saveOrUpdateSignUp: (data: any): Promise<any> => {
    return http.post("activity/vote/saveOrUpdateSignUp", data);
  },
  getWxAppletTemplate: (data: any): Promise<any> => {
    return http.post("wxApplet/vote/getWxAppletTemplate", data);
  },
  getTemplateByVoteId: (data: any): Promise<any> => {
    return http.post("wxApplet/vote/getTemplateByVoteId", data);
  },
  getThoroughDelVote: (data: any): Promise<any> => {
    return http.post("activity/vote/getThoroughDelVote", data);
  },
  getDepotVoteList: (data: any): Promise<any> => {
    return http.post("activity/vote/getDepotVoteList", data);
  },
  getAppletCode: (data: any): Promise<any> => {
    if (getSubName() == "wenjuanjia") {
      data.appletSource = 7;
    }
    return http.post("/wxApplet/vote/getAppletCode", data);
  },
  getPlayerVerify: (data: any): Promise<any> => {
    return http.post("/activity/player/getPlayerVerify", data);
  },
  getCommentList: (data: any): Promise<any> => {
    return http.post("/activity/vote/getCommentList", data);
  },
  getCommentShow: (data: any): Promise<any> => {
    return http.post("/activity/vote/getCommentShow", data);
  },
  getCommentDel: (data: any): Promise<any> => {
    return http.post("/activity/vote/getCommentDel", data);
  },
  getVotingDetailList: (data: any): Promise<any> => {
    return http.post("/activity/vote/getVotingDetailList", data);
  },

  getWxQuestionList: (data: any): Promise<any> => {
    return http.post("/activity/question/getWxQuestionList", data);
  },

  getWxQuestionDelList: (data: any): Promise<any> => {
    return http.post("/activity/question/getWxQuestionDelList", data);
  },

  // getWxQuestionSetting: (data: any): Promise<any> => {
  //     return http.post('/activity/question/getWxQuestionSetting', data);
  // },
  // updateWxQuestionSetting: (data: any): Promise<any> => {
  //     return http.post('/activity/question/updateWxQuestionSetting', data);
  // },

  getWxQuestionDel: (data: any): Promise<any> => {
    return http.post("/activity/question/getWxQuestionDel", data);
  },

  getRetrieveWxQuestion: (data: any): Promise<any> => {
    return http.post("/activity/question/getRetrieveWxQuestion", data);
  },

  getWxQuestionCompletelyDel: (data: any): Promise<any> => {
    return http.post("/activity/question/getWxQuestionCompletelyDel", data);
  },
  // getPreAuthCode: (data: any): Promise<any> => {
  //   return http.post('/activity/component/getPreAuthCode', data);
  // },
  /**
   * 是否收藏
   */
  getCollectionWhether: (data: any): Promise<any> => {
    return http.post("/activity/collect/getCollectionWhether", data);
  },
  /**
   * 收藏list
   */
  getCollectionList: (data: any): Promise<any> => {
    return http.post("/activity/collect/getCollectionList", data);
  },
  /**
   * 活动收藏Page
   */
  getCollectionPage: (data: any): Promise<any> => {
    return http.post("/activity/collect/getCollectionPage", data);
  },
  /**
   * 取消收藏
   */
  getCollectionCancel: (data: any): Promise<any> => {
    return http.post("/activity/collect/getCollectionCancel", data);
  },
  /**
   * 设置收藏
   */
  getCollectionSetting: (data: any): Promise<any> => {
    return http.post("/activity/collect/getCollectionSetting", data);
  },
  /**
   * 10个随机案例或模板
   */
  getRecommendedCaseList: (data: any): Promise<any> => {
    return http.post("/activity/vote/getRecommendedCaseList", data);
  },
  /**
   * 彻底删除投票活动list
   */
  getThoroughDelVoteList: (data: any): Promise<any> => {
    return http.post("/activity/vote/getThoroughDelVoteList", data);
  },
  /**
   * pc-白名单设置
   */
  getWhiteSettingVote: (data: any): Promise<any> => {
    return http.post("/activity/vote/white/getWhiteSetting", data);
  },
  /**
   * pc-白名单list
   */
  getWhiteListVote: (data: any): Promise<any> => {
    return http.post("/activity/vote/white/getWhiteList", data);
  },
  /**
   * pc-白名单list page
   */
  getWhitePageVote: (data: any): Promise<any> => {
    return http.post("/activity/vote/white/getWhitePage", data);
  },
  /**
   * pc-批量添加白名单
   */
  batchAddWhiteVote: (data: any): Promise<any> => {
    return http.post("/activity/vote/white/batchAddWhite", data);
  },
  /**
   * pc-批量删除白名单
   */
  batchDelWhiteVote: (data: any): Promise<any> => {
    return http.post("/activity/vote/white/batchDelWhite", data);
  },
  /**
   * pc-更新白名单设置
   */
  updateWhiteSettingVote: (data: any): Promise<any> => {
    return http.post("/activity/vote/white/updateWhiteSetting", data);
  },
  /**
   * pc-投票记录标记有/无效(投票记录对应的选手也会加减票)
   */
  getVotingDetailValid: (data: any): Promise<any> => {
    return http.post("/activity/vote/getVotingDetailValid", data);
  },
  /**
   * 查看投票的公众号授权信息
   */
  getVoteAuthInfoList: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.appletSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.appletSource = 7;
    }
    return http.post("/activity/component/getVoteAuthInfoList", data);
  },
  /**
   * 获取预授权码
   */
  getPreAuthCode: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.appletSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.appletSource = 7;
    }
    return http.post("/activity/component/getPreAuthCode", data);
  },
  /**
   * 保存公众号授权信息
   */
  getVoteAuthInfo: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.appletSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.appletSource = 7;
    }
    return http.post("/activity/component/getVoteAuthInfo", data);
  },
  /**
   * 删除公众号授权信息
   */
  delVoteAuthInfo: (data: any): Promise<any> => {
    return http.post("/activity/component/delVoteAuthInfo", data);
  },
  /**
   * 上传图片接口
   */
  imageUploadApi: (data: any): Promise<any> => {
    return http.post("/upload/image", data);
  },
  getVotingDetailDownload: (data: any): Promise<any> => {
    return http.post("/activity/vote/download/getVotingDetailDownload", data);
  },
  getRedParkDownload: (data: any): Promise<any> => {
    return http.post("/activity/vote/download/getRedParkDownload", data);
  },
  getStatisticsPlayerDownload: (data: any): Promise<any> => {
    return http.post(
      "/activity/vote/download/getStatisticsPlayerDownload",
      data
    );
  },
  getAllVotingDownload: (data: any): Promise<any> => {
    return http.post("/activity/vote/download/getAllVotingDownload", data);
  },
  // 下载选手文件
  getPlayerFileDownload: (data: any): Promise<any> => {
    return http.post("/activity/vote/download/getPlayerFileDownload", data);
  },
  // 获取选手排行
  getPlayerRankPage: (data: any): Promise<any> => {
    return http.post("/activity/player/getPlayerRankPage", data);
  },
  // 投票活动置顶
  updateVoteTop: (data: any): Promise<any> => {
    return http.post("/activity/vote/updateVoteTop", data);
  },
  // 不进行token判断获取活动设置（现场投票）
  getSceneVoteSetting: (data: any): Promise<any> => {
    return http.post("/activity/vote/getSceneVoteSetting", data);
  },
};
